"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _Accordion = _interopRequireDefault(require("@mui/material/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var Theme = _interopRequireWildcard(require("../../theme"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var _PlanDisplayBlock = _interopRequireDefault(require("./PlanDisplayBlock"));
var _system = require("@mui/system");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable require-jsdoc */

var StyledAccordionSummary = (0, _system.styled)(_AccordionSummary["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    "&.MuiAccordionSummary-root": {
      padding: "10px",
      border: "none"
    },
    "&.MuiAccordionSummary-root.Mui-expanded": {
      backgroundColor: theme.palette.primary.main,
      margin: "8px 0 8px 0",
      "&>:last-child": {
        color: "#FFFFFF !important"
      }
    },
    "& .MuiAccordionSummary-content": {
      margin: "10px",
      color: Theme.colors.mainTextGrey
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "10px",
      "&>p": {
        color: "#ffffff",
        fontWeight: "900",
        fontSize: "24px !important"
      }
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      color: Theme.colors.mainTextGrey,
      padding: "12px"
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      padding: "12px",
      color: "#fffff"
    },
    '& .MuiAccordionSummary-expandIconWrapper:hover': {
      backgroundColor: "#bfbfbf",
      borderRadius: "50%"
    }
  };
});
var PlanOverview = function PlanOverview(props) {
  (0, _react.useEffect)(function () {
    if (props.events) {
      props.events.record('view_plan');
    }
  }, []);
  var _getUnusedBenefits = function _getUnusedBenefits() {
    var unused = [];
    Object.keys(props.plan).map(function (benefit) {
      var isUnused = true;
      props.plan[benefit].some(function (design) {
        var _design$coverage;
        if ((_design$coverage = design.coverage) !== null && _design$coverage !== void 0 && _design$coverage.isSelected) {
          isUnused = false;
          return true;
        }
        return false;
      });
      if (isUnused) {
        unused.push(benefit);
      }
      return null;
    });
    return unused;
  };
  var plan = props.plan,
    whitelabel = props.whitelabel;
  var styles = {
    contentBlock: {
      backgroundColor: Theme.colors.surface,
      boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
      display: 'block',
      margin: 'auto auto 30px auto',
      padding: '30px',
      position: 'relative',
      zIndex: Theme.zIndex.container
    },
    expansionRoot: {
      boxShadow: 'none'
    },
    expansionSummary: {
      padding: '0',
      '&$expanded': {
        backgroundColor: "".concat(Theme.colors.darkBlue),
        color: "".concat(Theme.colors.surface)
      }
    },
    downloadBtnContainer: {
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-end',
      marginBottom: 10
    }
  };
  if (!props.plan) {
    return /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
      whitelabel: whitelabel
    });
  }
  var unusedBenefits = _getUnusedBenefits();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.downloadBtnContainer
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    transparent: true,
    onClick: function onClick() {
      return props.downloadPlanDesign();
    },
    customStyle: {
      '&:hover': {
        backgroundColor: 'lightgrey'
      }
    }
  }, _i18n["default"].t(_tokens["default"].buttons.download))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.contentBlock
  }, unusedBenefits.indexOf('lifeInsurance') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.lifeInsurance))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.lifeInsurance,
    type: "lifeInsurance"
  })), unusedBenefits.indexOf('deathDismemberment') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.accidentalDeathAndDismemberment))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.deathDismemberment,
    type: "deathDismemberment"
  })), unusedBenefits.indexOf('dependentLife') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.dependentLife))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.dependentLife,
    type: "dependentLife"
  })), unusedBenefits.indexOf('ltd') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.longTermDisability))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.ltd,
    type: "ltd"
  })), unusedBenefits.indexOf('std') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.shortTermDisability))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.std,
    type: "std"
  })), unusedBenefits.indexOf('criticalIllness') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllness))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.criticalIllness,
    type: "criticalIllness"
  })), unusedBenefits.indexOf('dental') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.dental))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.dental,
    type: "dental"
  })), unusedBenefits.indexOf('drugs') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.drugs))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.drugs,
    type: "drugs"
  })), unusedBenefits.indexOf('healthcare') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.healthcare))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.healthcare,
    type: "healthcare"
  })), unusedBenefits.indexOf('outOfCountry') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.outOfCountry))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.outOfCountry,
    type: "outOfCountry"
  })), unusedBenefits.indexOf('efap') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.employeeFamilyAssistance))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.efap,
    type: "efap"
  })), unusedBenefits.indexOf('virtualHealthcare') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.virtualHealthCare))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.virtualHealthcare,
    type: "virtualHealthcare"
  })), unusedBenefits.indexOf('spendingAccounts') === -1 && /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    sx: styles.expansionRoot,
    defaultExpanded: true
  }, /*#__PURE__*/_react["default"].createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "none"
  }, _i18n["default"].t(_tokens["default"].titles.spendingAccounts))), /*#__PURE__*/_react["default"].createElement(_PlanDisplayBlock["default"], {
    data: plan.spendingAccounts,
    type: "spendingAccounts"
  }))));
};
var _default = exports["default"] = PlanOverview;